import InfoIconWithText from './InfoIconWithText'

export default InfoIconWithText;
